import React from "react";
import "../less/main.less";
import DOMPurify from 'utils/sanitize';
import { Preloader } from "MWComponents";
import { filterByEnvironment } from "../../../../helpers/utils/environmentFilter";

export default function template() {
  const { widget, toggleFaqTab, title, display } = this.props,
    items = widget.data ? filterByEnvironment(widget.data) : [];

    const rows = items.sort((a, b) => a.order - b.order).map(item => {
      const question = item.title_ua;
      const answer = item.desc_ua;
      return (
        <div className="faq-new-full-admin__row" key={item.id}>
          <h3 className="faq-new-full-admin__question" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(question) }}></h3>
          <div className="faq-new-full-admin__answer" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(answer) }}></div>
        </div>
      );
    });

  return (
    items.length ?
      (
        <div className={`faq-new-full-admin${display === "block" ? " faq-new-full-admin_display-block" : ""}`}>
          <div className="container">
            {(title || toggleFaqTab) && (
              <div className="faq-new-full-admin__top">
                {title && <h2 className="faq-new-full-admin__title">{this.l10n(title)}</h2>}
                {toggleFaqTab && <button className="faq-new-full-admin__btn" onClick={toggleFaqTab}>{this.l10n('FAQ_FULL_NEW_BTN')}</button>}
              </div>
            )}
            <div className="faq-new-full-admin__body">
              {rows}
            </div>
          </div>
        </div>
      ) : <Preloader />
  );
}
